import React, { Component } from 'react'
import Snackbar from 'material-ui/Snackbar'

class SignUpField extends Component {
  constructor(props) {
    super(props)

    this._handleChange = this._handleChange.bind(this)
    this._handleClick = this._handleClick.bind(this)

    this.state = {
      email: '',
      subject: props.subject || '',
      label: props.label || 'Sign Up',
      message: props.message || 'Mailing List',
      snackbarOpen: false
    }
  }

  _handleChange (event) {
    this.setState({ 'email': event.target.value})
  }

  _handleClick (event) {
    event.preventDefault();
    const payload = this.state
    console.log()

    window.analytics.identify(payload, {
        integrations: {
          'Webhooks': false
        }
      })
    window.analytics.track('Signup Form Submitted',
        payload,
        {
          integrations: {
            'Webhooks': false
          }
        },
        ()=> {
      this.setState({ snackbarOpen: true })
    })
  }

  render () {
    const label = this.props.label || 'Sign Up'
    return (
      <div className="InputAddOn">
        <input
          className="InputAddOn-field"
          onChange={this._handleChange}
          placeholder="Email address" />
        <button
          className="InputAddOn-item"
          onClick={this._handleClick}>
          {label}
        </button>
        <Snackbar
          autoHideDuration={4000}
          message="Thanks, we'll be in touch soon!"
          onRequestClose={()=> this.setState({snackbarOpen: false})}
          open={this.state.snackbarOpen}
          bodyStyle={{ backgroundColor: "#aa82ff"}}
          contentStyle={{ backgroundColor: "#aa82ff"}}
        />
      </div>
    )
  }
}

export default SignUpField



// WEBPACK FOOTER //
// ./src/components/Footer/SignUpField.js